import React, { useEffect, useState } from "react";

import API from "./API";
import FullWidthDashboardPortal from "./FullWidthDashboardPortal";
import MainDashboardPortal from "./MainDashboardPortal";
import RightDashboardPortal from "./RightDashboardPortal";

export default function Dashboard() {
  const [status, setStatus] = useState(null);
  const [settings, setSettings] = useState({});

  useEffect(() => {
    const dashboardSettings = API.getDashboardSettings();

    dashboardSettings
      .post()
      .then((responseData) => {
        // console.log("responseData", responseData);
        setSettings(responseData);
        setStatus("success");
      })
      .catch((e) => {
        setStatus("error");
      });

    return () => dashboardSettings.cancel();
  }, []);

  if (!status) return null; // wait for settings to load

  return (
    <>
      <FullWidthDashboardPortal />
      <MainDashboardPortal settings={settings} />
      <RightDashboardPortal settings={settings} />
    </>
  );
}
